(function () {
  'use strict';

  var instances = new Map();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function initOne(root) {
    if (!root || root.hasAttribute('data-announcement-slider-initialized')) {
      return;
    }

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-announcement-slide]'));
    if (slides.length <= 1) {
      return;
    }

    var track = root.querySelector('[data-announcement-slider-track]');
    if (!track) {
      return;
    }

    var autoplayEnabled = root.dataset.autoplay === 'true';
    var delay = toInt(root.dataset.delay, 4000);
    var pauseOnHover = root.dataset.pauseOnHover === 'true';

    var state = {
      root: root,
      track: track,
      slides: slides,
      index: 0,
      timer: null
    };

    function setFocusable(slide, enabled) {
      var focusables = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      focusables.forEach(function (el) {
        if (enabled) {
          if (el.hasAttribute('data-announcement-prev-tabindex')) {
            var prev = el.getAttribute('data-announcement-prev-tabindex');
            el.removeAttribute('data-announcement-prev-tabindex');
            if (prev === 'null') {
              el.removeAttribute('tabindex');
            } else {
              el.setAttribute('tabindex', prev);
            }
          } else if (el.getAttribute('tabindex') === '-1') {
            el.removeAttribute('tabindex');
          }
        } else {
          if (!el.hasAttribute('data-announcement-prev-tabindex')) {
            el.setAttribute('data-announcement-prev-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'null');
          }
          el.setAttribute('tabindex', '-1');
        }
      });
    }

    function updateHeight(activeSlide) {
      // Use scrollHeight to include internal padding/content reliably.
      state.track.style.height = activeSlide.scrollHeight + 'px';
    }

    function setActive(nextIndex) {
      state.index = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        var isActive = i === state.index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        setFocusable(slide, isActive);
      });

      updateHeight(slides[state.index]);
    }

    function start() {
      if (!autoplayEnabled || prefersReducedMotion()) {
        return;
      }
      stop();
      state.timer = window.setInterval(function () {
        setActive(state.index + 1);
      }, delay);
    }

    function stop() {
      if (state.timer) {
        window.clearInterval(state.timer);
        state.timer = null;
      }
    }

    function onMouseEnter() {
      if (pauseOnHover) stop();
    }

    function onMouseLeave() {
      if (pauseOnHover && !root.classList.contains('is-paused')) start();
    }

    var pauseBtn = root.querySelector('[data-announcement-pause]');
    var pauseLabel = pauseBtn && pauseBtn.getAttribute('aria-label');
    var playLabel = (pauseBtn && pauseBtn.dataset.playLabel) || 'Play slideshow';

    function togglePause() {
      if (root.classList.contains('is-paused')) {
        root.classList.remove('is-paused');
        if (pauseBtn) pauseBtn.setAttribute('aria-label', pauseLabel);
        start();
      } else {
        root.classList.add('is-paused');
        if (pauseBtn) pauseBtn.setAttribute('aria-label', playLabel);
        stop();
      }
    }

    function onResize() {
      updateHeight(slides[state.index]);
    }

    // Initial state
    root.setAttribute('data-announcement-slider-initialized', 'true');
    setActive(0);
    start();

    if (pauseBtn) {
      pauseBtn.addEventListener('click', togglePause);
    }

    // Events
    if (pauseOnHover) {
      root.addEventListener('mouseenter', onMouseEnter);
      root.addEventListener('mouseleave', onMouseLeave);
      root.addEventListener('focusin', onMouseEnter);
      root.addEventListener('focusout', onMouseLeave);
    }

    window.addEventListener('resize', onResize);

    // Save instance for cleanup
    var key = root.getAttribute('data-section-id') || root.id || root;
    instances.set(key, {
      stop: stop,
      destroy: function () {
        stop();
        if (pauseBtn) pauseBtn.removeEventListener('click', togglePause);
        window.removeEventListener('resize', onResize);
        if (pauseOnHover) {
          root.removeEventListener('mouseenter', onMouseEnter);
          root.removeEventListener('mouseleave', onMouseLeave);
          root.removeEventListener('focusin', onMouseEnter);
          root.removeEventListener('focusout', onMouseLeave);
        }
        root.removeAttribute('data-announcement-slider-initialized');
      }
    });
  }

  function initAll(container) {
    var scope = container || document;
    var roots = scope.querySelectorAll('[data-announcement-slider]');
    roots.forEach(function (root) {
      initOne(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target) return;
    initAll(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    if (!evt || !evt.target) return;
    var root = evt.target.querySelector && evt.target.querySelector('[data-announcement-slider]');
    if (!root) return;

    var key = root.getAttribute('data-section-id') || root.id || root;
    var inst = instances.get(key);
    if (inst && inst.destroy) {
      inst.destroy();
      instances.delete(key);
    }
  });
})();
